import { ItineraryService } from 'src/app/services/itinerary.service';
import { Injectable, NgZone } from '@angular/core';
import { POY_TYPE } from '../app.constants';
import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Localizzazione } from '../models/localizzazione';
import * as Constants from '../../app/app.constants';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CacheService } from 'ionic-cache';
import { Api } from '.';
import { reject } from 'q';
import { FavouriteService } from './favourite.service';
import { Preferito } from '../models/preferito';
import { EventService } from './event.service';
import { PoiService } from './poi.service';
import { Evento } from '../models/evento';
import { AuthService } from './auth.service';
import { Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  counter: number = 0;
  lastUserLocation: Localizzazione;
  lastUserGpsLocation: Localizzazione;

  distanceUserGPSFromCenter: number = -1; //km 
  userInPlace: boolean;


  formattedAddress: String;
  addressSearch: string;
  addressResults: Array<string> = new Array();
  showAddressLoader = false;
  indirizzoRicerca: String;
  intervalHandle: any = null;
  background: boolean = false;

  constructor(
    private emailComposer: EmailComposer,
    public platform: Platform,
    private geolocation: Geolocation,
    private translateService: TranslateService,
    private favouriteService: FavouriteService,
    private eventService: EventService,
    private poiService: PoiService,
    private itineraryService: ItineraryService,

    private httpClient: HttpClient,
    private cache: CacheService,
    public auth: AuthService,
    public api: Api,
    public ngZone: NgZone,
    private storage: Storage
  ) {
    platform.ready().then(() => {
      if (platform.is('cordova')) {
        //Subscribe on pause
        this.platform.pause.subscribe(() => {
          //Hello pause
          console.log('in background....');
          this.background = true;
        });

        this.platform.resume.subscribe(() => {
          this.background = false;
          console.log('riprende... ');

          console.log(this.auth.isAuthenticated());
        });
      }
    });


    this.favouriteFromStorageToDBInterval();


    this.getPreferedLocation().then(
      (res: Localizzazione) => {
        this.lastUserLocation = res;
      },
      err => {
        console.log(err);
      }
    );

    this.getUserGpsLocation().then(
      (res: Localizzazione) => {
        this.lastUserGpsLocation = res;

        let distance = this.getDistanceFromLatLonInKm(
          this.lastUserGpsLocation.latitude,
          this.lastUserGpsLocation.longitude,
          Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.LATITUDE,
          Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.LONGITUDE
        );

        //Quando intercetto la posizione dell'utente, posso impostare se si trova nei paraggi oppure a distanza
        if ( distance < Constants.DISTANCE_THRESOLD_IN_PLACE ) {
          this.userInPlace = true;
        } else {
          this.userInPlace = false;
        }

      

        console.log(`getUserGpsLocation ${this.lastUserGpsLocation.indirizzo} Distance: ${distance}`);
      },
      err => {
        console.log(err);
      }
    );



  }

  getDistanceNearMe() {
    return new Promise(resolve => {
      this.storage.get('NEARME_LIMIT_DISTANCE').then(val => {
        if (val) {

          //console.log('STORAGE - getDistanceNearMe ' + val);
          resolve(val);
        } else {
          //console.log('STORAGE - getDistanceNearMe CONS ' + Constants.NEARME_LIMIT_DISTANCE);

          resolve('' + Constants.NEARME_LIMIT_DISTANCE);
        }
      });
    });
  }

  condividiPoi(detail) {
    let newVariable: any;
    const title = detail.title;

    let text = '\n' + detail.title;
    if (detail.shortDescription) {
      text += '\n\n' + detail.shortDescription;
    }
    if (detail.periodoEventoLong) {
      text += '\n\nQuando: ' + detail.periodoEventoLong;
    }
    text += 'Scopri di più -> ';

    let url = environment.api.baseUrl + 'web/detail/';

    if (
      detail.typeElement.key === POY_TYPE.ATTRACTOR.KEY ||
      detail.typeElement.key === POY_TYPE.RESTAURANT.KEY ||
      detail.typeElement.key === POY_TYPE.ACCOMODATION.KEY
    ) {
      url += detail.typeElement.key + '/';
    }

    url += detail.id;

    newVariable = window.navigator;

    if (newVariable && newVariable.share) {
      newVariable
        .share({
          title: title,
          text: text,
          url: url
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing', error));
    } else {
      alert('share not supported');
    }
  }

  condividiEvento(detail) {
    let newVariable: any;
    const title = detail.title;
    let text = '';
    if (detail.shortDescription) {
      text += '\n\n' + detail.shortDescription;
    }
    if (detail.periodoEventoLong) {
      text += '\n\nQuando:' + detail.periodoEventoLong;
    }
    text += 'Scopri di più -> ';

    let url = environment.api.baseUrl + 'web/detail/event/';
    url += detail.id;

    newVariable = window.navigator;

    if (newVariable && newVariable.share) {
      newVariable
        .share({
          title: title,
          text: text,
          url: url
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing', error));
    } else {
      alert('share not supported');
    }
  }

  loadFromCache(path) {
    if ( !this.cache ) {
      console.error('cache ERROR!');
    }
    

    this.cache.enableCache(true);

    const headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang
    });

    const options = { headers: headers };

    const cacheKey = path + '&' + this.translateService.currentLang;
    const request = this.httpClient.get(path, options);
    return this.cache.loadFromObservable(cacheKey, request);
  }

  latLngFromLocation(query: string) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.GEOCODE_LOCATION_URL_BASE}${Constants.GEOCODE_LOCATION_KEY}${Constants.GEOCODE_LOCATION_URL_SEARCH}${query}`;

      // let path = `${Constants.GEOCODE_URL}${query}.js?key=${Constants.GEOCODE_KEY}`;

      this.httpClient.get(path).subscribe(
        async (res: any) => {
          let elenco = [];
          if (res) {
            res.forEach(item => {
              let findItem = elenco.find(
                x => x.alternative_names === item.display_name
              );
              if (!findItem) {
                let obj = {
                  alternative_names: item.display_name,
                  lat: item.lat,
                  lon: item.lon
                };
                elenco.push(obj);
              }
            });
          }

          resolve(elenco);
        },
        err => {
          console.error('Nessun risultato geocode');
          
          reject(null);
        }
      );
    });
  }

  //Aggiorna la posizione con la posizione attuale
  setCurrentLocationFromGps() {
    return new Promise(resolve => {
      this.geolocation
        .getCurrentPosition()
        .then(resp => {

          console.log('SHARESERVICE - Recupero la posizione utente');

          this.lastUserGpsLocation = new Localizzazione();
          this.lastUserGpsLocation.latitude = resp.coords.latitude;
          this.lastUserGpsLocation.longitude = resp.coords.longitude;
          this.lastUserGpsLocation.dataAcquisizione = new Date();
          this.lastUserGpsLocation.userGpsLocation = true;

          this.setIndirizzoFromCoord(this.lastUserGpsLocation).then(res => {
            this.storage.set(Constants.STORAGE_KEY_USER_POSITION, res);

            resolve();
          });
        })
        .catch(error => {
          resolve();
        });
    });
  }







  //Aggiorna la posizione con la posizione attuale
  setPreferedLocationFromGps() {
    return new Promise(resolve => {
      this.geolocation
        .getCurrentPosition()
        .then(resp => {

          console.log('SHARESERVICE - Recupero la posizione utente');

          this.lastUserLocation = new Localizzazione();
          this.lastUserLocation.latitude = resp.coords.latitude;
          this.lastUserLocation.longitude = resp.coords.longitude;
          this.lastUserLocation.dataAcquisizione = new Date();
          this.lastUserLocation.userGpsLocation = true;

          this.setIndirizzoFromCoord(this.lastUserLocation).then(res => {
            this.storage.set(Constants.STORAGE_KEY_POSITION, res);

            resolve();
          });
        })
        .catch(error => {
          resolve();
        });
    });
  }




  // Recupero la posizione dell'utente
  getUserGpsLocation() {
    return new Promise(resolve => {

      //console.log('getUserGpsLocation');

        this.storage.get(Constants.STORAGE_KEY_USER_POSITION).then(
          userGPSStorage => {
            if (userGPSStorage) {

              //Se ho la posizioneGPS dallo storage, lo recupero
              //Controllo che non sia più vecchio di 10 minuti
              this.lastUserGpsLocation = userGPSStorage;
              if ( new Date().getTime() - new Date( this.lastUserGpsLocation.dataAcquisizione ).getTime() > 1000 * 60 * 10 ) {
                console.error('SHARESERVICE - GPS Scaduto - lo richiedo');
                this.setCurrentLocationFromGps().then( res => {
                  resolve( this.lastUserGpsLocation );
                });
              } else {
                resolve( this.lastUserGpsLocation );
              }

            } else {
              //Altrimenti aggiorno la posizione, ed al termine lo ritorno

              this.setCurrentLocationFromGps().then( res => {
                resolve( this.lastUserGpsLocation );
              });

            }
          },
          err => {
            //Se ho un problema con lo storage, faccio il primo set
              this.setCurrentLocationFromGps().then( res => {
                resolve( this.lastUserGpsLocation );
              });
          }
        );





    });
  }





  setIndirizzoFromCoord(location: Localizzazione) {
    return new Promise(resolve => {
      const urlSearch =
        'https://nominatim.openstreetmap.org/reverse?format=jsonv2&osm_type=W&lat=' +
        location.latitude +
        '&lon=' +
        location.longitude;

        /*
      console.log('urlSearch');
      console.log(urlSearch);
      */

      this.loadFromCache(urlSearch).subscribe(
        (res: any) => {
          if (res) {
            const positionInfos: any = res;
            if (positionInfos.address.town) {
              location.indirizzo = positionInfos.address.town;
            } else if (positionInfos.address.city) {
              location.indirizzo = positionInfos.address.city;
            } else if (positionInfos.address.village) {
              location.indirizzo = positionInfos.address.village;
            }
          }
          resolve(location);
        },
        err => {
          resolve(location);
        }
      );
    });
  }

  setCurrentLocationFromLatLon(latitude: number, longitude: number) {
    return new Promise(resolve => {
      this.lastUserLocation = new Localizzazione();
      this.lastUserLocation.latitude = latitude;
      this.lastUserLocation.longitude = longitude;
      this.lastUserLocation.userGpsLocation = false;
      this.lastUserLocation.dataAcquisizione = new Date();

      this.setIndirizzoFromCoord(this.lastUserLocation).then((res: any) => {
        this.storage.set(Constants.STORAGE_KEY_POSITION, res);

        resolve();
      });
    });
  }
  removePreferedLocation() {
    return new Promise(resolve => {
      this.lastUserLocation = null;
      this.storage.set(Constants.STORAGE_KEY_POSITION, this.lastUserLocation);
      resolve();
    });
  }

  getPreferedLocation() {
    return new Promise(resolve => {
      this.storage.get(Constants.STORAGE_KEY_POSITION).then(
        userStorage => {
          if (userStorage) {
            this.lastUserLocation = userStorage;
          } else {
            this.lastUserLocation = new Localizzazione();
            this.lastUserLocation.latitude =
              Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.LATITUDE;
            this.lastUserLocation.longitude =
              Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.LONGITUDE;
            this.lastUserLocation.dataAcquisizione = new Date();
            this.lastUserLocation.indirizzo =
              Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.ADDRESS;
            this.lastUserLocation.userGpsLocation = false;

          }
          resolve(this.lastUserLocation);
        },
        err => {
          this.lastUserLocation = new Localizzazione();
          this.lastUserLocation.latitude =
            Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.LATITUDE;
          this.lastUserLocation.longitude =
            Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.LONGITUDE;
          this.lastUserLocation.dataAcquisizione = new Date();
          this.lastUserLocation.indirizzo =
            Constants.COMUNE_ATTUALE.GEOCODE_DEFAULT_LOCATION.ADDRESS;
          this.lastUserLocation.userGpsLocation = false;

          resolve(this.lastUserLocation);
        }
      );
    });
  }

  // 1000 * 60 indica che viene eseguita ogni 1 minuti
  favouriteFromStorageToDBInterval() {
    const intervalMs = 1000 * 60;
    if (this.intervalHandle === null) {
      this.intervalHandle = setInterval(() => {
        if (!this.background) {
          if (
            this.auth &&
            this.auth.isAuthenticated() &&
            this.auth.user &&
            this.auth.user.sub
          ) {
            const idUser = this.auth.user.sub.split('|').join('-');

            this.favouriteFromStorageToDB(idUser).then(
              (res: any) => {
                this.favouriteService.favoritesFromDBtoStorage(idUser, 0, 100);
              },
              err => {
                console.log(err);
              }
            );
          }
        }
      }, intervalMs);
    } else {
      clearInterval(this.intervalHandle);
      this.intervalHandle = null;
    }
  }

 

  favouriteFromStorageToDB(idUser: any) {
    return new Promise((resolve, reject) => {
      this.favouriteService.getAllFavorite().then(result => {
        let favoritesFromStorage: Array<{
          id: string;
          type: string;
          idFavorite: string;
        }>;
        favoritesFromStorage = result;

        /**
         * Recupero tutti i favourite dallo store
         * Per ogni elemento controllo che abbiamo impostato il valore di idFavourite
         * Se non ha impostato il valore idFavourite allora vuol dire che non è ancora stato inserito nel DB, per questo motivo ho bisogno di recuperare l'intero oggetto ed inserirlo
         */

        if (favoritesFromStorage) {

          //console.log('SYNC - favouriteFromStorageToDB - I preferiti locali sono:' + favoritesFromStorage.length);

          for (const favorite of favoritesFromStorage) {
            //Se non ha idFavourite, vuol dire che deve essere aggiunto al db dei preferiti
            if (!favorite.idFavorite) {

              let favoriteToAdd: Preferito = new Preferito();

              //Per poterlo aggiungere abbiamo bisogno dell'intero oggetto

              if (favorite.type === Constants.POY_TYPE.EVENT.KEY) {

                //ricerca negli eventi
                this.eventService.getEventById(favorite.id).then(
                  (res: Preferito) => {

                    /**
                     * Questa parte di codice è uguale ai tre metodi, devo vedere di metterla in comune
                     */

                    favoriteToAdd = res;
                    favoriteToAdd.idUser = idUser;
                    favoriteToAdd.idPoi = res.id;
                    const seq = this.favouriteService.addFavoriteToDb(
                      favoriteToAdd
                    );
                    seq.subscribe(
                      (resAddFavToDb: any) => {
                        //console.log('SYNC - Aggiunto nuovo Favourite nel DB');
                        this.favouriteService.setFavorite(
                          favoriteToAdd.idPoi,
                          favoriteToAdd.typeElement.key,
                          resAddFavToDb.id
                        );
                        resolve();
                      },
                      err => {
                        console.log('SYNC - Errore nel salvataggio');
                        resolve();
                      }
                    );

                  /***  */
                  },
                  err => {
                    console.log(err);
                    resolve();
                  }
                );
              } else if ( favorite.type === Constants.POY_TYPE.ITINERARY.KEY ) {

                //ricerca negli itinery
                this.itineraryService.getItineraryById(favorite.id).then(
                  (res: Preferito) => {

                    /**
                     * Questa parte di codice è uguale ai tre metodi, devo vedere di metterla in comune
                     */
                    favoriteToAdd = res;
                    favoriteToAdd.idUser = idUser;
                    favoriteToAdd.idPoi = res.id;
                    const seq = this.favouriteService.addFavoriteToDb(
                      favoriteToAdd
                    );
                    seq.subscribe(
                      (resAddFavToDb: any) => {
                        //console.log('SYNC - Aggiunto nuovo Favourite nel DB');
                        this.favouriteService.setFavorite(
                          favoriteToAdd.idPoi,
                          favoriteToAdd.typeElement.key,
                          resAddFavToDb.id
                        );
                        resolve();
                      },
                      err => {
                        console.log('SYNC - Errore nel salvataggio');
                        resolve();
                      }
                    );
                  },
                  err => {
                    console.log(err);
                    resolve();
                  }
                );
                /** */

              }
              else if (
                favorite.type === Constants.POY_TYPE.ACCOMODATION.KEY ||
                favorite.type === Constants.POY_TYPE.ATTRACTOR.KEY ||
                favorite.type === Constants.POY_TYPE.RESTAURANT.KEY
              ) {
                //ricerca nei poi
                this.poiService.getPoiById(favorite.id).then(
                  (res: Preferito) => {

                      /**
                     * Questa parte di codice è uguale ai tre metodi, devo vedere di metterla in comune
                     */
                    favoriteToAdd = res;
                    favoriteToAdd.idUser = idUser;
                    favoriteToAdd.idPoi = res.id;
                    const seq = this.favouriteService.addFavoriteToDb(
                      favoriteToAdd
                    );
                    seq.subscribe(
                      (res: any) => {
                        //console.log('SYNC - Aggiunto nuovo Favourite nel DB');
                        this.favouriteService.setFavorite(
                          favoriteToAdd.idPoi,
                          favoriteToAdd.typeElement.key,
                          favoriteToAdd.id
                        );
                        resolve();
                      },
                      err => {
                        console.log('SYNC - Errore nel salvataggio');
                        resolve();
                      }
                    );

                    /** */

                  },
                  err => {
                    console.log(err);
                    resolve();
                  }
                );
              }
            } else {
              resolve();
            }
          }
        } else {
          resolve();
        }
        resolve();
      });
    });
  }

  /* Andrebbero messe in una librearia di utilità :( */

  getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    let R = 6371; // Radius of the earth in km
    let dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    let dLon = this.deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in km
    return d;
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
}
